import requests from "./httpService";
import request from "./httpService_admin";
const AdminServices = {
  // registerAdmin: async (body) => {
  //   return requests.post("/admin/register", body);
  // },
 
  // loginEmployee: async (body) => {
  //   return requests.post(`/employee/login`, body)
  // },

  // forgetPassword: async (body) => {
  //   return requests.put("/employee/forgot-password", body);
  // },

  // resetPassword: async (body) => {
  //   return requests.put("/employee/reset-password", body);
  // },

  // signUpWithProvider: async (body) => {
  //   return requests.post("/admin/signup", body);
  // },

  addStaff: async (body) => {
    return requests.post("/users/add", body);
  },
  getAllStaff: async (body) => {
    return requests.get("/users/", body);
  },
  getStaffById: async (id, body) => {
    return requests.get(`/users/${id}`, body);
  },

  updateStaff: async (id, body) => {
    return requests.put(`/users/update/${id}`, body);
  },

  updateStaffStatus: async (id, body) => {
    return requests.put(`/users/status/${id}`, body);
  },

  deleteStaff: async (id) => {
    return requests.delete(`/users/delete/${id}`);
  },
  getAllProfile: async () => {
    return requests.get("/profile/");
  },
  getAllState: async () => {
    return request.get("/state/");
  },
  getAllStateCity: async () => {
    return requests.get("/city/getAllCityState/");
  },
};

export default AdminServices;
